<template>
  <v-toolbar app color="#fff">
    <v-toolbar-title class="headline">
      <span class="font-weight-regular title">Ш++</span><strong class="vertical-line"> | </strong>
      <span class="font-weight-regular title">Peer-To-Peer</span><strong class="vertical-line"> | </strong>
      <span class="font-weight-regular title">Досье студента</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-select
        class="my-2 mx-5"
        v-model="filter"
        :items="filters"
        item-text="title"
        label="Фильтр"
        hide-details
        color="success"
      ></v-select>
      <UserSearch
        v-if="isDossier"
        :header="true"
        :icon-size="30"
        :body2="true"
        :font-weight-light="true"
        :white-text="false"
      ></UserSearch>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
  import UserSearch from "./user/UserSearch";

  export default {
    components: {UserSearch},
    data() {
      return {
        isDossier: false,
        filter: null,

        filters: [
          { title: 'Общий прогресс', value: null },
          { title: 'Невидимые оценки', value: 'reviewFeedbacks' },
          { title: 'Видимые предупреждения', value: 'visibleWarnings' },
          { title: 'Дропы', value: 'drops' },
          { title: 'Лучший ревьювер', value: 'bestReviewer' },
          { title: 'Добряк', value: 'inflatedMarks' },
        ]
      }
    },
    watch: {
      "$route": "checkDossier",

      filter() {
        this.$store.state.filter = this.filter;
      }
    },
    created() {
      this.checkDossier();
    },
    methods: {
      checkDossier() {
        this.isDossier = this.$route.name === "dossier"
      }
    }
  }
</script>

<style>
  .vertical-line {
    color: #4CAF50;
  }

  .v-toolbar {
    box-shadow: none !important;
  }

  .v-toolbar__content {
    border-bottom: 2px solid #4CAF50 !important;
    height: 60px !important;
  }

</style>
